import React, { useEffect, useState, useCallback } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";

const TEXT = {
    generalConfig: "Cấu hình chung",
    minDeposit: "Nạp tối thiểu",
    bettingRevenue: "Doanh thu cược",
    BanCa: 'BẮN CÁ',
    Slot: 'SLOTS',
    Casino: 'CASINO',
    GameViet: 'GAME VIỆT',
    TheThao: 'THỂ THAO',
    save: "Lưu",
}

const SetupCondition = () => {
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    // State
    const [maxTurn, setMaxTurn] = useState();
    const [minDeposit, setMinDeposit] = useState(0); // Chỉ dùng 1 biến minDeposit chung
    
    // State DTC (Doanh thu cược)
    const [dtcBanCa, setDTCBanCa] = useState(0);
    const [dtcSlot, setDTCSlot] = useState(0);
    const [dtcCasino, setDTCCasino] = useState(0);
    const [dtcGameViet, setDTCGameViet] = useState(0);
    const [dtcTheThao, setDTCTheThao] = useState(0);

    const [messageApi, contextHolder] = message.useMessage();

    const showError = useCallback((errorMessage) => {
        messageApi.open({
            type: 'error',
            content: errorMessage,
        });
    }, [messageApi]);

    const getDataConfig = useCallback(async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data?.data || res.data;
            
            // Xử lý dữ liệu cũ nếu cấu trúc BE chưa đổi kịp (flatten dữ liệu)
            // Ưu tiên lấy ở root, nếu không có thì fallback vào các phase cũ để hiển thị
            const savedMinDeposit = data?.minDeposit || data?.playPhases?.phase1?.minDeposit || data?.playPhases?.phase2?.minDeposit || 0;
            
            // Lấy DTC requirements (ưu tiên root -> fallback phase 2 cũ)
            const dtcRequirements = data?.dtcRequirements || data?.playPhases?.phase2?.dtcRequirements || {};

            setMinDeposit(savedMinDeposit);
            setDTCBanCa(dtcRequirements[3] || dtcRequirements['3'] || 0);
            setDTCSlot(dtcRequirements[1] || dtcRequirements['1'] || 0);
            setDTCCasino(dtcRequirements[4] || dtcRequirements['4'] || 0);
            setDTCGameViet(dtcRequirements[2] || dtcRequirements['2'] || 0);
            setDTCTheThao(dtcRequirements[5] || dtcRequirements['5'] || 0);
            
            setMaxTurn(data?.maxTurns || data?.maxDailyTurns);
        } catch (err) {
            console.log(err);
            showError("Không thể tải dữ liệu cấu hình");
        }
    }, [showError]);

    useEffect(() => {
        getDataConfig();
    }, [getDataConfig]);

    const handleChangeInput = (value, key) => {
        switch (key) {
            case 'minDeposit': setMinDeposit(value); return;
            case 'dtcBanCa': setDTCBanCa(value); return;
            case 'dtcSlot': setDTCSlot(value); return;
            case 'dtcCasino': setDTCCasino(value); return;
            case 'dtcGameViet': setDTCGameViet(value); return;
            case 'dtcTheThao': setDTCTheThao(value); return;
            default: return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);

            if (
                !validNumber(minDeposit) || 
                !validNumber(dtcBanCa) || !validNumber(dtcSlot) || !validNumber(dtcCasino) || 
                !validNumber(dtcGameViet) || !validNumber(dtcTheThao)
            ) {
                showError("Vui lòng nhập số hợp lệ");
                return;
            }

            // Tạo cấu trúc config mới phẳng hơn (không còn lồng nhau phase1/phase2)
            const config = {
                minDeposit: parseInt(minDeposit),
                dtcRequirements: {
                    1: parseInt(dtcSlot),
                    2: parseInt(dtcGameViet),
                    3: parseInt(dtcBanCa),
                    4: parseInt(dtcCasino),
                    5: parseInt(dtcTheThao),
                }
            };

            // Nếu có maxTurns, thêm vào config
            if (maxTurn) {
                config.maxTurns = parseInt(maxTurn);
            }

            const body = {
                config: config
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
            setIsShowModalSuccess(true);
            
            // Reload data sau khi update thành công
            setTimeout(() => {
                getDataConfig();
            }, 1000);
        } catch (err) {
            console.log(err);
            showError(err?.response?.data?.message || "Cập nhật cấu hình thất bại");
            setIsShowModalSuccess(false);
        }
    };

    const validNumber = (value) => {
        if (value === undefined || value === null || value === "") {
            return false;
        }
        const number = parseInt(value);
        return !isNaN(number) && number >= 0; // Cho phép số 0 nếu cần thiết
    }

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderInputNumber = (key, defaultValue, changeInput, max, label) => {
        return (
            <div className={`flex w-full items-center mt-4`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    <InputNumber
                        key={key}
                        style={{ width: "100%" }}
                        value={defaultValue}
                        onChange={changeInput}
                        max={max}
                        min={0}
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                        controls={true}
                    />
                </div>
            </div>
        )
    }

    const renderSection = (title, children) => {
        return (
            <div className="w-full mb-6 p-4 border rounded-lg shadow-sm bg-white">
                <div className="text-lg font-bold mb-4 text-gray-700 border-b pb-2">{title}</div>
                {children}
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            {minDeposit !== undefined && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                
                                {/* Phần cấu hình chung (Nạp tối thiểu) */}
                                {renderSection(TEXT.generalConfig,
                                    renderInputNumber(
                                        "minDeposit",
                                        minDeposit, 
                                        (e) => handleChangeInput(e, 'minDeposit'), 
                                        1000000000, 
                                        TEXT.minDeposit
                                    )
                                )}

                                {/* Phần Doanh thu cược */}
                                {renderSection(TEXT.bettingRevenue,
                                    <>
                                        {renderInputNumber(
                                            "dtcBanCa",
                                            dtcBanCa, 
                                            (e) => handleChangeInput(e, 'dtcBanCa'), 
                                            1000000000, 
                                            TEXT.BanCa
                                        )}

                                        {renderInputNumber(
                                            "dtcSlot",
                                            dtcSlot, 
                                            (e) => handleChangeInput(e, 'dtcSlot'), 
                                            1000000000, 
                                            TEXT.Slot
                                        )}

                                        {renderInputNumber(
                                            "dtcCasino",
                                            dtcCasino, 
                                            (e) => handleChangeInput(e, 'dtcCasino'), 
                                            1000000000, 
                                            TEXT.Casino
                                        )}

                                        {renderInputNumber(
                                            "dtcGameViet",
                                            dtcGameViet, 
                                            (e) => handleChangeInput(e, 'dtcGameViet'), 
                                            1000000000, 
                                            TEXT.GameViet
                                        )}

                                        {renderInputNumber(
                                            "dtcTheThao",
                                            dtcTheThao, 
                                            (e) => handleChangeInput(e, 'dtcTheThao'), 
                                            1000000000, 
                                            TEXT.TheThao
                                        )}
                                    </>
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-end">
                                <Button type="primary" onClick={handleShowModal} size="large">
                                    {TEXT.save}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                />
            )}
        </div>
    );
};

export default SetupCondition;